import { GenIcon } from '../helpers/IconBase.es.js';

const PageOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 32 32", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M12.668 16H22.6666",
          stroke: "#DBDBDB",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M12.668 20.6452H22.6666",
          stroke: "#DBDBDB",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M12.668 11.3119H22.6666",
          stroke: "#DBDBDB",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M9.40005 11.2455C9.39119 11.2455 9.38241 11.2472 9.37423 11.2507C9.36605 11.2541 9.35864 11.2591 9.35244 11.2654C9.34623 11.2718 9.34135 11.2793 9.33807 11.2875C9.3348 11.2958 9.33321 11.3046 9.33339 11.3135C9.33339 11.3508 9.36405 11.3801 9.40139 11.3801C9.41919 11.3801 9.43629 11.3731 9.44901 11.3607C9.46172 11.3482 9.46904 11.3313 9.46939 11.3135C9.46871 11.2954 9.46115 11.2783 9.44825 11.2657C9.43536 11.253 9.41811 11.2458 9.40005 11.2455",
          stroke: "#DBDBDB",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M9.40005 15.9323C9.39119 15.9323 9.38241 15.9341 9.37423 15.9375C9.36605 15.9409 9.35864 15.946 9.35244 15.9523C9.34623 15.9586 9.34135 15.9661 9.33807 15.9744C9.3348 15.9826 9.33321 15.9914 9.33339 16.0003C9.33339 16.0376 9.36405 16.0683 9.40139 16.0683C9.41942 16.0683 9.43672 16.0611 9.44947 16.0484C9.46222 16.0356 9.46939 16.0183 9.46939 16.0003C9.46904 15.9821 9.46158 15.9648 9.44861 15.9521C9.43565 15.9394 9.41821 15.9323 9.40005 15.9323",
          stroke: "#DBDBDB",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M9.40005 20.5788C9.39119 20.5788 9.38241 20.5805 9.37423 20.584C9.36605 20.5874 9.35864 20.5924 9.35244 20.5988C9.34623 20.6051 9.34135 20.6126 9.33807 20.6209C9.3348 20.6291 9.33321 20.6379 9.33339 20.6468C9.33339 20.6841 9.36405 20.7134 9.40139 20.7134C9.41919 20.7135 9.43629 20.7065 9.44901 20.694C9.46172 20.6815 9.46904 20.6646 9.46939 20.6468C9.46871 20.6287 9.46115 20.6116 9.44825 20.599C9.43536 20.5863 9.41811 20.5791 9.40005 20.5788",
          stroke: "#DBDBDB",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M27 9.88889V22.1111C27 23.4077 26.4849 24.6512 25.5681 25.5681C24.6512 26.4849 23.4077 27 22.1111 27H9.88889C8.59227 27 7.34877 26.4849 6.43192 25.5681C5.51508 24.6512 5 23.4077 5 22.1111V9.88889C5 8.59227 5.51508 7.34877 6.43192 6.43192C7.34877 5.51508 8.59227 5 9.88889 5H22.1111C23.4077 5 24.6512 5.51508 25.5681 6.43192C26.4849 7.34877 27 8.59227 27 9.88889Z",
          stroke: "#DBDBDB",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};

export { PageOutlined };
